import { EligibilityInputState } from './types';

export const isBothRequiredFieldsAreFilled = (
  inputsState: EligibilityInputState
) => inputsState.passportNumber && inputsState.issuanceCountry;

export const isAllInputsEmpty = (inputsState: EligibilityInputState) =>
  Object.values(inputsState).every((value) => !value);
